import { LinkTheme } from "../../Link.types";
import { palette } from "../../../../../theming/bca/bca-palette";

const SECONDARY_2_600 = palette.hexForSupporting("secondary_2_600");

const theme: LinkTheme = {
	visited: {
		"&:visited": {
			color: SECONDARY_2_600,
			textDecorationColor: SECONDARY_2_600,
		},
	},
};

export default theme;
